module.exports = __webpack_public_path__ + "static/media/DEM.c6448123.png";